import { __assign } from "tslib";
import qs from "qs";
export var qsParse = function (str, options) {
    return qs.parse(str, __assign({ ignoreQueryPrefix: true }, options));
};
export var qsStringify = function (obj, options) {
    return qs.stringify(obj, __assign({ arrayFormat: "repeat" }, options));
};
